import { render, staticRenderFns } from "./CockpitMatryoshkaItemHistoryTab.vue?vue&type=template&id=c481613c&scoped=true"
import script from "./CockpitMatryoshkaItemHistoryTab.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaItemHistoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c481613c",
  null
  
)

export default component.exports